import "../main-content/main-content.css";
import React from "react";
import StartWidget from "../start-widget/StartWidget";

function MainContent() {
  return (
    <React.Fragment>
      <div className="container-fluid m-0 p-0">
        <StartWidget />
      </div>
    </React.Fragment>
  );
}

export default MainContent;